import HeaderV5 from "@/components/landing-v5/HeaderV5";
import FooterV5 from "@/components/landing-v5/FooterV5";
import SEOSchema from "@/components/SEOSchema";
import { useEffect } from "react";

const Privacy = () => {
  useEffect(() => {
    // SEO optimizations
    document.title = "Privacy Policy - Show Up";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Privacy Policy for Show Up - PACT Habit Tracker. We protect your data and only use analytics to improve your experience.');
    }

    const canonicalUrl = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl) {
      canonicalUrl.setAttribute('href', 'https://showupagain.com/privacy');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SEOSchema 
        type="website"
        name="Privacy Policy - Show Up"
        description="Privacy Policy for Show Up - PACT Habit Tracker"
        url="https://showupagain.com/privacy"
      />
      
      <HeaderV5 />
      
      <main className="container mx-auto px-4 pt-32 pb-16">
        <div className="max-w-4xl mx-auto">
          <header className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
            <p className="text-xl text-muted-foreground">
              How Show Up protects and uses your information
            </p>
          </header>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
              <p className="text-muted-foreground leading-relaxed">
                Show Up only uses cookies and analytics to improve the user experience. 
                We do not sell your personal data to third parties. Your privacy and trust 
                are fundamental to our service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Data We Collect</h2>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Basic usage analytics to understand how you interact with our app</li>
                <li>Technical data such as device type and browser information</li>
                <li>Information you voluntarily provide when creating habits and tracking progress</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">How We Use Your Data</h2>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>To provide and improve the Show Up service</li>
                <li>To analyze app performance and user experience</li>
                <li>To ensure the security and proper functioning of our platform</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Your Rights</h2>
              <p className="text-muted-foreground leading-relaxed">
                You have the right to access, update, or delete your personal information at any time. 
                You can also opt out of analytics tracking through your device settings.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about this Privacy Policy or how we handle your data, 
                please contact us at:{" "}
                <a 
                  href="mailto:hello@showupagain.com" 
                  className="text-primary hover:underline"
                >
                  hello@showupagain.com
                </a>
              </p>
            </section>

            <section>
              <p className="text-sm text-muted-foreground">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </section>
          </div>
        </div>
      </main>

      <FooterV5 />
    </div>
  );
};

export default Privacy;